import React from 'react'
import Enlace from '../../models/Enlace';
import GaleriaImagenes from '../GaleriaImagenes/GaleriaImagenes';

import './GenerarModales.scss';

const GenerarModales = (datosModales: any[]) => {

    const pintarDescripciones = (descripcion: string[]) => {

        const descripcionItem = descripcion.map((item: string, index: number) => {

            const estiloParrafo = (index === 0)?"mt-3 mb-3 textoJustificado":"mb-3 textoJustificado"

            return (
                <p key={index} className={estiloParrafo}>
                    { item }
                </p>                
            )
        });

        return descripcionItem;

    };

    const pintarListaDescricion = (tituloLista: string, itemsLista: any[]) => {

        const elementos = itemsLista.map((elemento: string, index: number) => {
            return <li key={index} className="textoJustificado">{elemento}</li>
        })

        const listaDescricion = (
            <div>
                <p className="mb-2 subtitulo-modal">
                    { tituloLista }
                </p>
                <ul>
                    { elementos }
                </ul>
            </div>
        )

        return listaDescricion;

    }

    const pintarEnlacesInteres = (enlacesInteres: Enlace[]) => {

        const elementos = enlacesInteres.map((elemento: Enlace, index: number) => {
            return (
                <a key={index} className="btn btn-secondary btn-sm mb-3 ms-2" href={elemento.direccion} target="_blank" rel="noreferrer" role="button">
                    { elemento.descripcion }
                </a>
            )
        })

        const enlaces = (
            <div>
                <p className='text-start text-semibold'>Enlaces de interés:</p>
                 {
                    elementos
                 }
            </div>
        )

        return enlaces;

    }

    const pintarIconoModal = (tipoIcono: string, icono: string) => {

        return tipoIcono==='IMG'?(
                <img className='iconosRutas' src={icono} alt='TipoActividad'></img>
            ) : (
                <i className={ icono }></i>
            )

    }

    const pintarModal = (datosModal: any, index: number) => {

        return (
            <div key={index} className="portfolio-modal modal fade" id={datosModal.idModal} aria-labelledby={datosModal.idModal} aria-hidden="true">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center pb-5">
                            <div className="container">
                                <div className="row justify-content-center">
                                    <div className="col-lg-8">
                                        
                                        <h2 className="portfolio-modal-title text-secondary text-uppercase mb-0">
                                            { datosModal.titulo }
                                        </h2>
                                        
                                        <div className="divider-custom">
                                            <div className="divider-custom-line"></div>
                                            <div className="divider-custom-icon">
                                                {
                                                    pintarIconoModal(datosModal.tipoIcono, datosModal.icono)
                                                }
                                            </div>
                                            <div className="divider-custom-line"></div>
                                        </div>

                                        <GaleriaImagenes nombreGaleria={datosModal.idModal} imagenes={datosModal.imagenes} esModal={true} />
                                        
                                        {
                                            (datosModal.descripcion!=null)?pintarDescripciones(datosModal.descripcion):(<></>)
                                        }
                                        
                                        {
                                            (datosModal.tituloLista!=null)?pintarListaDescricion(datosModal.tituloLista, datosModal.elementosLista):(<></>)
                                        }

                                        {
                                            (datosModal.tituloTarifa!=null)?pintarListaDescricion(datosModal.tituloTarifa, datosModal.descricionTarifa):(<></>)
                                        }
                                        
                                        {
                                            (datosModal.enlacesInteres!=null)?pintarEnlacesInteres(datosModal.enlacesInteres):(<></>)
                                        }
                                        
                                        <button className="btn btn-primary" data-bs-dismiss="modal">
                                            <i className="fas fa-xmark fa-fw"></i>
                                            Cerrar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

    const pintarModales = (datosModales: any[]) => {

        let modales = datosModales.map((datos: any, index: number) => {
            return pintarModal(datos, index)
        })

        return modales;

    }

    return (
         pintarModales(datosModales)
    )
}

export default GenerarModales